<template>
  <div class="article_details">
    <div class="content">
      <div class="data_detail" v-for="item in passData" :key="item.id">
        <div class="top_title">
          <div class="title text_one_line" @title="item.title">{{item.title}}</div>
          <div @click="goBack" class="back">
            <div class="back_txt">Back</div>
          </div>
        </div>
        <div class="other_infor">
          <span class="time">{{item.publish}}</span>
          <!-- <span class="author">Author:{{item.author}}</span> -->
          <span class="source">Source:{{item.source}}</span>
        </div>
        <div class="abstract">{{item.summary}}</div>
        <div class="detail_txt">
          <div class="paragraph" v-html="item.content">{{item.content}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { newsDetail } from "@/common/js/http/version3Api.js";
export default {
  name: "ArticleDetails",
  mounted() {
    this.articleId = this.$route.query.id;
    this.getNewsDetail();
  },
  data() {
    return {
      articleId: 0,
      passData: [],
    };
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/brand/BigFrame/logoDetail/Detail/LyricSearch",
        query: {
          id: sessionStorage.getItem("id"),
        },
      });
    },
    async getNewsDetail() {
      let data = {
        id: this.$route.query.id,
      };
      let res = await newsDetail(data);
      if (res.code == 200) {
        this.passData = res.result;
      }
    },
  },
};
</script>

<style scoped>
.go_back {
  cursor: pointer;
  padding: 0 15px;
  height: 65px;
  padding-top: 16px;
  line-height: 65px;
  background: #fff;
}
.back_txt {
  width: 60px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  color: #8590a6;
  text-align: center;
  background: #f2f3f4;
  border: 1px solid rgba(0, 0, 0, 0);
  font-family: RCR;
}
.content {
  background: #eff0f1;
  /* padding: 15px; */
}
.data_detail {
  background: #fff;
  padding: 24px;
}
.content .title {
  font-size: 20px;
  color: #4e5671;
  font-family: RCB;
}
.other_infor {
  font-size: 12px;
  color: #80828d;
  margin: 16px 0;
  font-family: RCR;
}
.other_infor span {
  margin-right: 20px;
}
.abstract {
  padding: 18px 20px;
  font-size: 14px;
  text-align: justify;
  line-height: 21px;
  background: #e8eaef;
  margin-bottom: 16px;
  font-family: RCR;
  border-radius: 5px;
  color: #4f5362;
}
.paragraph {
  font-size: 18px;
  color: #4e5671;
  text-align: justify;
  line-height: 26px;
  margin-bottom: 30px;
  text-indent: 2em;
  font-family: RCR;
}
.top_title {
  width: 100%;
  display: flex;
}
.top_title .title {
  width: 95%;
  background: #fff;
  word-break: break-all;
}
.top_title .back {
  margin: 0 auto;
  width: 60px;
  height: 30px;
  color: rgba(133, 144, 166, 1);
  background: rgba(242, 243, 244, 1);
  border-radius: 20px;
}
</style>